import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel, useCurrency } from '@websolutespa/bom-mixer-hooks';
import { IconLlmChevronRightCircle } from '@websolutespa/bom-mixer-icons';
import { slugify } from 'transliteration';

const ProductWrapper = _a => {
  var {
      children
    } = _a,
    item = __rest(_a, ["children"]);
  // const label = useLabel();
  const classNames = getClassNames('llm__product', `llm__product--${item.productType}`);
  return item.url ? jsx("a", {
    className: classNames,
    href: item.url,
    target: "_blank",
    rel: "noreferrer",
    "aria-label": item.title,
    children: children
  }) : jsx("div", {
    className: classNames,
    children: children
  });
};
const Product = props => {
  const {
    item
  } = props;
  const label = useLabel();
  const currency = useCurrency();
  function asNumber(value) {
    return value ? Number(value) : 0;
  }
  const price = asNumber(item.price);
  const hasPriceLabel = item.priceLabel != null;
  const hasPrice = item.price != null && !hasPriceLabel;
  const fullPrice = asNumber(item.fullPrice) || price;
  const hasFullPriceLabel = item.fullPriceLabel != null;
  const availability = asNumber(item.availability);
  const hasAvailabilityLabel = item.availabilityLabel != null;
  const hasAvailability = item.availability != null && !hasAvailabilityLabel;
  const labelKey = item.label ? `-${slugify(item.label)}` : '';
  return jsxs(ProductWrapper, Object.assign({}, item, {
    children: [item.media.type === 'image' && jsxs("div", {
      className: "llm__product-media",
      children: [jsx("div", {
        className: "llm__product-asset",
        children: jsx("img", {
          src: item.media.src,
          alt: ""
        })
      }), item.label && jsx("div", {
        className: "llm__product-label",
        style: {
          background: `var(--llm-product-label${labelKey}-background, var(--llm-product-label-background))`,
          color: `var(--llm-product-label${labelKey}-foreground, var(--llm-product-label-foreground))`
        },
        children: item.label
      })]
    }), jsxs("div", {
      className: "llm__product-content",
      children: [item.sku && jsx("div", {
        className: "llm__product-sku",
        children: item.sku
      }), jsxs("div", {
        className: "llm__product-grow",
        children: [item.title && jsx("div", {
          className: "llm__product-title",
          dangerouslySetInnerHTML: {
            __html: item.title
          }
        }), item.abstract && jsx("div", {
          className: "llm__product-abstract",
          dangerouslySetInnerHTML: {
            __html: item.abstract
          }
        })]
      }), hasPrice && jsxs("div", {
        className: "llm__product-prices",
        children: [jsx("div", {
          className: "llm__product-price",
          children: currency(price)
        }), fullPrice > price && jsx("div", {
          className: "llm__product-fullprice",
          children: hasFullPriceLabel ? item.fullPriceLabel : currency(fullPrice)
        })]
      }), hasPriceLabel && jsxs("div", {
        className: "llm__product-prices",
        children: [jsx("div", {
          className: "llm__product-price",
          children: item.priceLabel
        }), fullPrice > price && jsx("div", {
          className: "llm__product-fullprice",
          children: hasFullPriceLabel ? item.fullPriceLabel : currency(fullPrice)
        })]
      }), hasAvailability && (availability ? jsx("div", {
        className: "llm__product-available",
        children: label('llm.availability', {
          availability: availability
        })
      }) : jsx("div", {
        className: "llm__product-soldout",
        children: label('llm.soldOut')
      })), hasAvailabilityLabel && (availability ? jsx("div", {
        className: "llm__product-available",
        children: item.availabilityLabel
      }) : jsx("div", {
        className: "llm__product-soldout",
        children: item.availabilityLabel
      })), item.cta && jsxs("div", {
        className: "llm__product-cta",
        children: [jsx("span", {
          children: item.cta
        }), " ", jsx(IconLlmChevronRightCircle, {})]
      })]
    })]
  }));
};

export { Product, ProductWrapper };
//# sourceMappingURL=product.js.map
